var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex flex-column h100"},[_c('MessageList',{attrs:{"chat":_vm.chat,"messages":_vm.messages}}),(_vm.chat.queue === 'own')?_c('MessageInput',{attrs:{"disabled":_vm.chat.status !== _vm.profile.userId || !_vm.profile.iam.chatWrite,"chat":_vm.chat,"messages":_vm.messages}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }